
















































































import { Component, Vue } from "vue-property-decorator";
// @ts-ignore
import { VueGoodTable } from "vue-good-table";
import {
  CommonData,
  IUserInfo,
  ModalAddType,
  UserInfo,
  UserRole
} from "@/models";
import CommonService from "@/services/CommonService";

@Component({ components: { VueGoodTable } })
export default class SupplierTable extends Vue {
  private isLoading: boolean = true;
  private selectedSupplier: CommonData = new CommonData();
  private loginedUser: IUserInfo = this.$store.state.user;
  private eModalAddType = ModalAddType;

  private columns: any[] = [];
  private rows: CommonData[] = [];
  private eUserRole = UserRole;

  private searchOptions: any = {
    enabled: true,
    skipDiacritics: true,
    placeholder: "nhập gì đó..."
  };

  private paginationOptions: any = {
    enabled: true,

    perPage: 10,
    position: "bottom",
    perPageDropdownEnabled: false,
    jumpFirstOrLast: false,
    nextLabel: this.$t("common.table.next"),
    prevLabel: this.$t("common.table.prev"),
    firstLabel: "Đầu",
    lastLabel: "Cuối"
  };

  created() {
    this.setTableColumn();
    this.getListSupplier();
  }

  /**
   * Call API get list user
   */
  async getListSupplier() {
    CommonService.getAllSupplier().then(res => {
      if (res.status === 200) {
        this.rows = res.data.map((item: any) => new CommonData(item));
        this.isLoading = false;
      }
    });
  }

  /**
   * Config comlumn
   */
  setTableColumn() {
    this.columns = [
      {
        label: "#",
        field: "id",
        hidden: true
      },
      {
        label: "STT",
        field: "index",
        width: "50px",
        sortable: false
      },
      {
        label: "Mã",
        field: "code"
      },
      {
        label: "Tên",
        field: "name"
      },

      {
        label: "SĐT",
        tooltip: "số điện thoại",
        field: "phone"
      },
      {
        label: "Email",
        field: "email"
      },
      {
        label: "Địa chỉ",
        field: "address"
      },
      {
        label: "Ngân hàng",
        field: "bank"
      },
      {
        label: "Đ/C Ngân hàng",
        tooltip: "địa chỉ ngân hàng",
        field: "bankAddress"
      },
      {
        label: "TK Ngân hàng",
        tooltip: "tài khoản ngân hàng",
        field: "bankAccount"
      },
      {
        label: "IBAN",
        field: "iban"
      },
      {
        label: "GC",
        tooltip: "Ghi chú",
        field: "notice",
        width: "50px",
        sortable: false
      }
    ];
    if (
      this.loginedUser.role !== UserRole.GUEST &&
      this.loginedUser.role !== UserRole.ACCOUNTANT
    ) {
      this.columns.push({
        label: "",
        field: "action",
        width: "90px",
        sortable: false
      });
    }
  }

  hanldeSelectRow(row: CommonData) {
    if (
      this.loginedUser.role === UserRole.GUEST ||
      this.loginedUser.role === UserRole.ACCOUNTANT
    )
      return;
    this.selectedSupplier = row;
    setTimeout(() => this.$bvModal.show("modal-edit-supplier"), 10);
  }
}
